export default{
    configHeadData: [
        {
            title: "纳税人名称",
            prop: "companyName",
            width: "150",
        },
        {
            title: "公司代码",
            prop: "companyCode",
            width: "150",
        },
        {
          title: "所属期",
          prop: "period",
          width: "150"
        },
        {
            title: "事项名称",
            prop: "todoProjectBoard",
            width: "150",
        },
        {
            title: "办理期限",
            prop: "deadline",
            width: "150",
        },
        {
            title: "事项状态",
            prop: "agencyStatus",
            width: "150",
        },
    ],
    tablePagination:{
        pageNum: 1,
        pageSize: 50,
        total: 0,
        paginationkey:0
    },
    searchlist:[
        {
            prop: 'companyName',
            label: '纳税人名称',
            type: 'input',
        },
        {
            prop: 'companyCode',
            label: '公司代码',
            type: 'input',
        },
        {
            prop: 'period',
            label: '所属期',
            type: "datemonth",
            valueformat: 'yyyyMM'
        },
        {
            prop: 'todoProjectBoard',
            label: '事项名称',
            type: 'input',
        },
        {
            prop: 'deadline',
            label: '办理期限',
            valueformat: 'yyyy-MM-dd',
            type: 'date',
        },
    ],
    searchdata:{
        companyName:'',
        companyCode:"",
        period:"",
        todoProjectBoard:'',
        deadline:[],
    }
}
